export const environment = {
  production: true,  
 // apiBase: 'https://apponestopradio.com/os_website/',
   apiBase: 'https://theonestopradio.com/os_website/',
  // siteUrl: 'http://54.185.227.93', 
   siteUrl: 'https://theonestopradio.com/',
   devToolsProtection: true
};
